import { useEffect } from 'react';
import { useSnackbar } from '@planitgeo/treeplotter-ui-library';
import {
  subscribeQueuedSubmissionFailures,
  QueuedFailure,
} from 'common/infrastructure/remoteState/persistQueryClient';
import loggerService, { LoggerLevel } from 'common/infrastructure/log';
import { useLocales } from 'locales';

const FAILURE_KEYS: Record<QueuedFailure['kind'], string> = {
  submission: 'data.queued_submit_failed',
  photoLink: 'data.photo_link_failed',
};

/** Headless. Toasts when background work (an offline-queued submission, or attaching
 *  photos) permanently fails, since no caller is awaiting it. Mount once at the app root. */
export default function QueuedSubmissionFailureToaster(): null {
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();

  useEffect(
    () =>
      subscribeQueuedSubmissionFailures((failure: QueuedFailure) => {
        loggerService.log(LoggerLevel.ERROR, 'Queued work permanently failed', failure);
        enqueueSnackbar(
          translate(FAILURE_KEYS[failure.kind], { assetId: failure.reference ?? '—' }),
          { variant: 'error' }
        );
      }),
    [enqueueSnackbar, translate]
  );

  return null;
}
